import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';

/* json */
import * as id from '../../../assets/json/id.json';
import * as en from '../../../assets/json/en.json';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  API_URL = environment.API_URL;
  apiLang = new BehaviorSubject<string>('');
  lang = new BehaviorSubject<string>('');

  constructor(private httpClient: HttpClient, private router: Router) { }

  giveLang(lang_ans: string) {
    this.apiLang.next(this.API_URL + lang_ans + '/');
    this.lang.next(lang_ans);
  }

  getDataApi(param): Observable<any> {
    return this.httpClient.get<any>(this.apiLang.value + param).pipe(catchError(this.errorGetHandler.bind(this)));
  }
  
  getNextPage(param): Observable<any> {
    return this.httpClient.get<any>(param).pipe(catchError(this.errorHandler));
  }

  postDataApi(param, body): Observable<any> {
    return this.httpClient.post<any>(this.API_URL + param, (body)).pipe(catchError(this.errorHandler));
  }

  isLang() {
    return this.lang.value == 'id' ? (id as any).default : (en as any).default;
  }

  errorGetHandler(error: HttpErrorResponse) {
    this.router.navigate(['/server-error']);
    return throwError(error.message || "Server Error");
  } 

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
  
}
